"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Locale {
    constructor() {
        this.config = {
            currency: {
                name: 'টাকা',
                plural: 'টাকা',
                singular: 'টাকা',
                symbol: '৳',
                fractionalUnit: {
                    name: 'পয়সা',
                    singular: 'পয়সা',
                    plural: 'পয়সা',
                    symbol: '',
                },
            },
            texts: {
                and: 'এবং',
                minus: 'ঋণ',
                only: '',
                point: 'দশমিক',
            },
            numberWordsMapping: [
                { number: 10000000, value: 'কোটি' },
                { number: 100000, value: 'লাখ' },
                { number: 1000, value: 'হাজার' },
                { number: 100, value: 'শত' },
                { number: 99, value: 'নিরানব্বই' },
                { number: 98, value: 'আটানব্বই' },
                { number: 97, value: 'সাতানব্বই' },
                { number: 96, value: 'ছিয়ানব্বই' },
                { number: 95, value: 'পঁচানব্বই' },
                { number: 94, value: 'চুরানব্বই' },
                { number: 93, value: 'তিরানব্বই' },
                { number: 92, value: 'বিরানব্বই' },
                { number: 91, value: 'একানব্বই' },
                { number: 90, value: 'নব্বই' },
                { number: 89, value: 'ঊননব্বই' },
                { number: 88, value: 'অষ্টআশি' },
                { number: 87, value: 'সাতআশি' },
                { number: 86, value: 'ছিয়াশী' },
                { number: 85, value: 'পঁচাশী' },
                { number: 84, value: 'চুরাশী' },
                { number: 83, value: 'তিরাশী' },
                { number: 82, value: 'বিরাশী' },
                { number: 81, value: 'একাশী' },
                { number: 80, value: 'আশি' },
                { number: 79, value: 'ঊনআশি' },
                { number: 78, value: 'অষ্টাত্তর' },
                { number: 77, value: 'সাতাত্তর' },
                { number: 76, value: 'ছিয়াত্তর' },
                { number: 75, value: 'পঁচাত্তর' },
                { number: 74, value: 'চুয়াত্তর' },
                { number: 73, value: 'তিয়াত্তর' },
                { number: 72, value: 'বাহাত্তর' },
                { number: 71, value: 'একাত্তর' },
                { number: 70, value: 'সত্তর' },
                { number: 69, value: 'ঊনসত্তর' },
                { number: 68, value: 'অষ্টষষ্টি' },
                { number: 67, value: 'সাতষষ্টি' },
                { number: 66, value: 'ছেষষ্টি' },
                { number: 65, value: 'পঁয়ষট্টি' },
                { number: 64, value: 'চৌষট্টি' },
                { number: 63, value: 'তেষট্টি' },
                { number: 62, value: 'বাষট্টি' },
                { number: 61, value: 'একষট্টি' },
                { number: 60, value: 'ষাট' },
                { number: 59, value: 'ঊনষাট' },
                { number: 58, value: 'আটান্ন' },
                { number: 57, value: 'সাতান্ন' },
                { number: 56, value: 'ছাপ্পান্ন' },
                { number: 55, value: 'পঞ্চান্ন' },
                { number: 54, value: 'চুয়ান্ন' },
                { number: 53, value: 'তিপ্পান্ন' },
                { number: 52, value: 'বায়ান্ন' },
                { number: 51, value: 'একান্ন' },
                { number: 50, value: 'পঞ্চাশ' },
                { number: 49, value: 'ঊনপঞ্চাশ' },
                { number: 48, value: 'আটচল্লিশ' },
                { number: 47, value: 'সাতচল্লিশ' },
                { number: 46, value: 'ছেচল্লিশ' },
                { number: 45, value: 'পঁইঁতাল্লিশ' },
                { number: 44, value: 'চুয়াল্লিশ' },
                { number: 43, value: 'তেতাল্লিশ' },
                { number: 42, value: 'বিয়াল্লিশ' },
                { number: 41, value: 'একচল্লিশ' },
                { number: 40, value: 'চল্লিশ' },
                { number: 39, value: 'ঊনচল্লিশ' },
                { number: 38, value: 'আটত্রিশ' },
                { number: 37, value: 'সাঁইত্রিশ' },
                { number: 36, value: 'ছত্রিশ' },
                { number: 35, value: 'পঁইত্রিশ' },
                { number: 34, value: 'চৌত্রিশ' },
                { number: 33, value: 'তেত্রিশ' },
                { number: 32, value: 'বত্রিশ' },
                { number: 31, value: 'একত্রিশ' },
                { number: 30, value: 'ত্রিশ' },
                { number: 29, value: 'ঊনত্রিশ' },
                { number: 28, value: 'আঠাশ' },
                { number: 27, value: 'সাতাশ' },
                { number: 26, value: 'ছাব্বিশ' },
                { number: 25, value: 'পঁচিশ' },
                { number: 24, value: 'চব্বিশ' },
                { number: 23, value: 'তেইশ' },
                { number: 22, value: 'বাইশ' },
                { number: 21, value: 'একুশ' },
                { number: 20, value: 'বিশ' },
                { number: 19, value: 'ঊনিশ' },
                { number: 18, value: 'আঠারো' },
                { number: 17, value: 'সতেরো' },
                { number: 16, value: 'ষোলো' },
                { number: 15, value: 'পনেরো' },
                { number: 14, value: 'চৌদ্দ' },
                { number: 13, value: 'তেরো' },
                { number: 12, value: 'বারো' },
                { number: 11, value: 'এগারো' },
                { number: 10, value: 'দশ' },
                { number: 9, value: 'নয়' },
                { number: 8, value: 'আট' },
                { number: 7, value: 'সাত' },
                { number: 6, value: 'ছয়' },
                { number: 5, value: 'পাঁচ' },
                { number: 4, value: 'চার' },
                { number: 3, value: 'তিন' },
                { number: 2, value: 'দুই' },
                { number: 1, value: 'এক' },
                { number: 0, value: 'শূন্য' },
            ],
        };
    }
}
exports.default = Locale;
